
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("5Vcc4"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("5Vcc4", function(module, exports) {

let $44fbbc0519887415$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $44fbbc0519887415$var$load("694is"),
    $44fbbc0519887415$var$load("gfvIK"),
    $44fbbc0519887415$var$load("iUXaE"),
    $44fbbc0519887415$var$load("lTkx9"),
    $44fbbc0519887415$var$load("eRhBr"),
    $44fbbc0519887415$var$load("6HpsR"),
    $44fbbc0519887415$var$load("N3oqb"),
    $44fbbc0519887415$var$load("hZ2FX"),
    $44fbbc0519887415$var$load("9ZFGK"),
    $44fbbc0519887415$var$load("2hLAI"),
    $44fbbc0519887415$var$load("dCilB"),
    $44fbbc0519887415$var$load("h1yOv"),
    $44fbbc0519887415$var$load("1T8H1"),
    $44fbbc0519887415$var$load("fyKFO"),
    $44fbbc0519887415$var$load("d9sg7"),
    $44fbbc0519887415$var$load("l0N35"),
    $44fbbc0519887415$var$load("bU9L5"),
    $44fbbc0519887415$var$load("fuOfV"),
    $44fbbc0519887415$var$load("iZR3N"),
    $44fbbc0519887415$var$load("4zz48"),
    $44fbbc0519887415$var$load("jXM1T"),
    $44fbbc0519887415$var$load("cvcNg"),
    $44fbbc0519887415$var$load("jw3lv"),
    $44fbbc0519887415$var$load("7rqWx"),
    $44fbbc0519887415$var$load("aIze1"),
    $44fbbc0519887415$var$load("il8bj"),
    $44fbbc0519887415$var$load("4N1MY"),
    $44fbbc0519887415$var$load("kG5Ju"),
    $44fbbc0519887415$var$load("39XCn"),
    $44fbbc0519887415$var$load("3Cky6"),
    $44fbbc0519887415$var$load("jL1Ke"),
    $44fbbc0519887415$var$load("5MQ0D"),
    $44fbbc0519887415$var$load("aFLSJ"),
    $44fbbc0519887415$var$load("6fJCf"),
    $44fbbc0519887415$var$load("duEFL"),
    $44fbbc0519887415$var$load("6wr18"),
    $44fbbc0519887415$var$load("1pJPT"),
    $44fbbc0519887415$var$load("8zMmc"),
    $44fbbc0519887415$var$load("4x9Jx"),
    $44fbbc0519887415$var$load("7EorR"),
    $44fbbc0519887415$var$load("ffEVr"),
    $44fbbc0519887415$var$load("2EIkU"),
    $44fbbc0519887415$var$load("Wowvf"),
    $44fbbc0519887415$var$load("hhss7"),
    $44fbbc0519887415$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("8Bx4L"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("8Bx4L", function(module, exports) {

let $643b6f94a2aaf625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $643b6f94a2aaf625$var$load("iUXaE"),
    $643b6f94a2aaf625$var$load("lTkx9"),
    $643b6f94a2aaf625$var$load("6wr18"),
    $643b6f94a2aaf625$var$load("ffEVr"),
    $643b6f94a2aaf625$var$load("eCXJR"),
    $643b6f94a2aaf625$var$load("1VTX2"),
    $643b6f94a2aaf625$var$load("2EIkU"),
    $643b6f94a2aaf625$var$load("eRhBr"),
    $643b6f94a2aaf625$var$load("hZ2FX"),
    $643b6f94a2aaf625$var$load("hhss7"),
    $643b6f94a2aaf625$var$load("kT6dz"),
    $643b6f94a2aaf625$var$load("aAWLw"),
    $643b6f94a2aaf625$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("kKNjd"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("kKNjd", function(module, exports) {

let $f1be5a3a9886678f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1be5a3a9886678f$var$load("4ZKBo"),
    $f1be5a3a9886678f$var$load("3WmaY"),
    $f1be5a3a9886678f$var$load("7gL7H"),
    $f1be5a3a9886678f$var$load("7TnhR"),
    $f1be5a3a9886678f$var$load("hUbK8"),
    $f1be5a3a9886678f$var$load("gwGEC"),
    $f1be5a3a9886678f$var$load("l5nRU"),
    $f1be5a3a9886678f$var$load("bx5S2"),
    $f1be5a3a9886678f$var$load("7fsAO"),
    $f1be5a3a9886678f$var$load("1tkCm"),
    $f1be5a3a9886678f$var$load("ipIDQ"),
    $f1be5a3a9886678f$var$load("agv3Q"),
    $f1be5a3a9886678f$var$load("garBx"),
    $f1be5a3a9886678f$var$load("2CrXe"),
    $f1be5a3a9886678f$var$load("beMmd"),
    $f1be5a3a9886678f$var$load("l4MHo"),
    $f1be5a3a9886678f$var$load("k97np"),
    $f1be5a3a9886678f$var$load("by6h6"),
    $f1be5a3a9886678f$var$load("j3345"),
    $f1be5a3a9886678f$var$load("2J2X1"),
    $f1be5a3a9886678f$var$load("dWa0D"),
    $f1be5a3a9886678f$var$load("6Zg0V"),
    $f1be5a3a9886678f$var$load("e7Dyr"),
    $f1be5a3a9886678f$var$load("cPAXo"),
    $f1be5a3a9886678f$var$load("44j0l"),
    $f1be5a3a9886678f$var$load("fldAO"),
    $f1be5a3a9886678f$var$load("46GUH"),
    $f1be5a3a9886678f$var$load("dxcsb"),
    $f1be5a3a9886678f$var$load("gbejv"),
    $f1be5a3a9886678f$var$load("GD9EA"),
    $f1be5a3a9886678f$var$load("2hLAI"),
    $f1be5a3a9886678f$var$load("dCilB"),
    $f1be5a3a9886678f$var$load("1T8H1"),
    $f1be5a3a9886678f$var$load("fyKFO"),
    $f1be5a3a9886678f$var$load("d9sg7"),
    $f1be5a3a9886678f$var$load("l0N35"),
    $f1be5a3a9886678f$var$load("z9yIf"),
    $f1be5a3a9886678f$var$load("gnocL"),
    $f1be5a3a9886678f$var$load("694is"),
    $f1be5a3a9886678f$var$load("gfvIK"),
    $f1be5a3a9886678f$var$load("bgstx"),
    $f1be5a3a9886678f$var$load("8exG0"),
    $f1be5a3a9886678f$var$load("kT6dz"),
    $f1be5a3a9886678f$var$load("iUXaE"),
    $f1be5a3a9886678f$var$load("lTkx9"),
    $f1be5a3a9886678f$var$load("6wr18"),
    $f1be5a3a9886678f$var$load("3N1vv"),
    $f1be5a3a9886678f$var$load("hZVEi"),
    $f1be5a3a9886678f$var$load("fcsnw"),
    $f1be5a3a9886678f$var$load("ffEVr"),
    $f1be5a3a9886678f$var$load("eCXJR"),
    $f1be5a3a9886678f$var$load("1VTX2"),
    $f1be5a3a9886678f$var$load("ddvkk"),
    $f1be5a3a9886678f$var$load("3upHR"),
    $f1be5a3a9886678f$var$load("hhss7"),
    $f1be5a3a9886678f$var$load("Wowvf"),
    $f1be5a3a9886678f$var$load("eRhBr"),
    $f1be5a3a9886678f$var$load("hZ2FX"),
    $f1be5a3a9886678f$var$load("cKDij"),
    $f1be5a3a9886678f$var$load("7EorR"),
    $f1be5a3a9886678f$var$load("ce05o"),
    $f1be5a3a9886678f$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.627c2415.js.map
